












































































































import mixins from 'vue-typed-mixins';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import BuildEntityListComponent from '@/Shared/CommonEntityMixins/EntityListComponentMixin';
import LocationLookupDropdown from '@/Shared/LocationLookupDropdown.vue';
import { ActionMethod } from '@/Shared/CommonEntityMixins/Enums';
import { LotViolationCode } from './LotViolationCode';
import { UrlConfig, UrlOptions } from '@/Shared/CommonEntityMixins/UrlConfig';
import { AxiosResponse, AxiosRequestConfig } from 'axios';
import VatsAPI from '@/Shared/VatsAPI';
import { LocationLookupType } from '@/Stores/LookupStore';

const baseListComponent = BuildEntityListComponent<LotViolationCode>();
const lotViolationCodes = mixins(LocationBasedMixin, baseListComponent).extend({
    components: { LocationLookupDropdown },
    beforeMount() {
        if (this.lotID) {
            this.indexChangeLocationDropDown();
        }
    },
    data() {
        return {
            i18nPrefix: 'admin.lotMaintenance.lotViolationCodes',
            lotID: this.$route.query.lotID || null,
            LocationLookupType,
        };
    },
    computed: {
        entityUrls(): UrlOptions {
            const urls: UrlOptions = {
                get: {
                    url: `/${this.location}/lotmaintenance/getlotviolationcodes?lotID=${this.lotID}`,
                    urlAction: ActionMethod.GET
                },
                update: {
                    url: `/${this.location}/lotmaintenance/upsertlotviolationcodelkup`,
                    urlAction: ActionMethod.POST
                },
                delete: {
                    url: `/${this.location}/lotmaintenance/deletelotviolationcodelkup`,
                    urlAction: ActionMethod.PUT
                }
            };

            return urls;
        }
    },
    methods: {
        async indexChangeLocationDropDown() {
            this.cancelEdit();
            this.loadEntities();

            if (this.lotID) {
                await this.$router.replace({
                    name: this.$route.name ?? undefined,
                    query: {
                        lotID: this.lotID
                    }
                });
            }
        },
        add() {
            if (this.editItem && !this.editItem.recID) {
                return;
            }
            const newCode = {
                lotID: this.lotID,
            } as unknown as LotViolationCode;
            this.entities.splice(0, 0, newCode);
            this.edit(newCode);
        },
    },
    watch: {
        async 'editItem.code'(newCode: string) {
            if (!newCode) {
                return;
            }

            const payload = {
                location: this.location,
                lookupType: LocationLookupType.ViolationCode
            };
            const lookups = await this.$typedStore.modules.lookupsModule.actions.getLocationLookups(payload);
            if (lookups[newCode]) {
                this.editItem.description = lookups[newCode].description;
            }
        }
    }
});

export default lotViolationCodes;
